import { withInstall } from '@ll-plus/utils'

import TagCatalog from './src/tag-catalog.vue'

export const LlTagCatalog = withInstall(TagCatalog)
export default LlTagCatalog
export * from './src/tag-catalog'

declare module 'vue' {
  export interface GlobalComponents {
    LlTagCatalog: typeof TagCatalog
  }
}
